import React, {useReducer, createContext} from "react";
import reducer from "../reducer/sidebarReducer.js";
import PropTypes from "prop-types";


const initialState = {
    isSidebarOpen : false
};

export const SidebarContext = createContext({});
export const SidebarProvider = ({children}) =>{
    const[state, dispatch] = useReducer(reducer, initialState);
    const toggleSidebar = () =>{
        dispatch({type: "TOGGLE_SIDEBAR"});
    };
    return(
        <SidebarContext.Provider value={{...state, toggleSidebar}}>
            {children}
        </SidebarContext.Provider>
    );
};

// export const useSidebarContext = () => useContext(SidebarContext);
SidebarProvider.propTypes ={
    children: PropTypes.node
}